export default function loadCaptcha(siteKey){
    const script = document.createElement('script');

    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
    script.async = true;
      document.body.appendChild(script);


}